import styles from './IconDefault.module.scss';

export function IconSearch() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.2837 24.7003C9.91269 24.7003 5.55859 20.3462 5.55859 14.9752C5.55859 9.6041 9.91269 5.25 15.2837 5.25C20.6548 5.25 25.0089 9.6041 25.0089 14.9752C25.0089 20.3462 20.6548 24.7003 15.2837 24.7003ZM8.76874 12.5176C8.4926 12.9959 8.65647 13.6075 9.13477 13.8836C9.61306 14.1597 10.2246 13.9959 10.5008 13.5176C11.5582 11.6861 13.2719 10.4722 15.176 10.0005C15.7121 9.86763 16.039 9.32539 15.9061 8.78931C15.7733 8.25324 15.2311 7.92633 14.695 8.05915C12.2852 8.6562 10.109 10.1962 8.76874 12.5176Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M25.0089 14.9752C25.0089 17.694 23.8932 20.1522 22.0947 21.9171C20.3402 23.6386 17.936 24.7003 15.2837 24.7003C12.6648 24.7003 10.2877 23.6651 8.53923 21.9816C6.7018 20.2124 5.55859 17.7273 5.55859 14.9752C5.55859 12.3229 6.62028 9.9187 8.34184 8.16423C10.1067 6.3657 12.5649 5.25 15.2837 5.25C18.0359 5.25 20.521 6.3932 22.2902 8.23064"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M22.2387 31.0941C20.902 29.7574 20.8829 27.6092 22.1962 26.296L23.3851 25.1071C24.6983 23.7939 26.8465 23.8129 28.1832 25.1496L36.7625 33.7289C38.0992 35.0656 38.1183 37.2138 36.805 38.527L35.6161 39.7159C34.3029 41.0292 32.1547 41.0101 30.818 39.6735L22.2387 31.0941Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M15.2836 28.5711C18.0336 28.5711 20.593 27.7546 22.7325 26.3508C22.6887 27.1767 22.9823 28.0171 23.6132 28.648L31.1862 36.221C32.3661 37.401 34.2792 37.401 35.4591 36.221L36.5273 35.1528C37.7072 33.9729 37.7072 32.0599 36.5273 30.88L28.9542 23.307C28.3236 22.6763 27.4835 22.3827 26.6578 22.4262C28.0626 20.2863 28.8797 17.726 28.8797 14.975C28.8797 7.46608 22.7925 1.37891 15.2836 1.37891C7.77467 1.37891 1.6875 7.46608 1.6875 14.975C1.6875 18.7572 3.23189 22.1787 5.72445 24.6433"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="8.39453"
				cy="26.6875"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
			<circle
				cx="11.7695"
				cy="28.125"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
